import { SharedTypes } from '../enum';
export const getSharedTypes = () => {
    return [SharedTypes.COMPANY, SharedTypes.SHARED];
};
